<template>
  <GetStartedInfo
    cardImagePath="img/growth/groups-collapsable-section_minified.svg"
    :footerIconSrc="footerIconSrc"
    :footerText="footerText"
    header="Save time with group-based bulk actions"
    :listItems="listItems"
    @actionClicked="showModal"
  />
</template>

<script>
import { GroupsConsts } from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import GetStartedInfo from 'client/components/GetStartedInstructions/GetStartedInfo.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import VideoModal from 'client/components/Modal/VideoModal.vue';

const {
  systemGroupsWistiaIframeVideoUrl,
  systemGroupsWistiaVideoUrl,
  userGroupsWistiaIframeVideoUrl,
  userGroupsWistiaVideoUrl,
} = GroupsConsts;
const systemGroupTab = 'System Groups';
const userGroupTab = 'User Groups';

export default {
  name: 'GroupsGetStartedInfo',

  components: {
    GetStartedInfo,
  },

  data: () => ({
    footerIconSrc: 'img/icons/icon-info.svg',
    footerText: 'Try adding users and systems to the suggested groups below – or remove them if they don’t apply to you.',
    listItems: [
      {
        actionParameter: userGroupTab,
        actionText: 'Learn how',
        text: 'Efficiently provision **user groups** to applications, LDAP resources, networks, and more.',
      },
      {
        actionParameter: systemGroupTab,
        actionText: 'Learn how',
        text: 'Use **system groups** to manage user access and deploy policies at scale.',
      },
    ],
  }),

  methods: {
    showModal(tab) {
      EventHelper.triggerGroupsGettingStartedModalViewed();
      ModalEventBus.open({
        component: VideoModal,
        isLargeModal: true,
        componentProps: {
          openAtTab: tab,
          openVideoInNewModalButton: true,
          modalClosedAction: () => EventHelper.triggerGroupsGettingStartedModalDismissed(),
          videos: [
            {
              tabName: userGroupTab,
              iframeUrl: userGroupsWistiaIframeVideoUrl,
              videoUrl: userGroupsWistiaVideoUrl,
            },
            {
              tabName: systemGroupTab,
              iframeUrl: systemGroupsWistiaIframeVideoUrl,
              videoUrl: systemGroupsWistiaVideoUrl,
            },
          ],
        },
      });
    },
  },
};
</script>
